import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { appServices } from '@/data/AppServices';
import type { Vocabulary } from '@/domain/Models';

export function VocabularyDetailPage() {
  const { wordId } = useParams();
  const navigate = useNavigate();
  const [word, setWord] = useState<Vocabulary | null>(null);
  const [missing, setMissing] = useState(false);

  const load = useCallback(async () => {
    if (!wordId) {
      setMissing(true);
      return;
    }
    const item = await appServices.vocabulary.get(decodeURIComponent(wordId));
    setWord(item);
    setMissing(!item);
  }, [wordId]);

  useEffect(() => {
    void load();
  }, [load]);

  if (missing) {
    return (
      <div className="page stack">
        <div>找不到这个词</div>
        <button type="button" onClick={() => navigate('/vocabulary')}>
          返回
        </button>
      </div>
    );
  }
  if (!word) return <div className="page muted">加载中…</div>;

  return (
    <div className="page stack">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <strong style={{ fontSize: '1.25rem' }}>{word.term}</strong>
        <button
          type="button"
          className="icon-btn"
          onClick={() => void toggleFav()}
          aria-label={word.favorite ? '取消收藏' : '收藏'}
        >
          {word.favorite ? '♥' : '♡'}
        </button>
      </div>
      {word.itemKind === 'PHRASE' && <span className="chip">短语</span>}
      {word.ipa && <div className="muted">{word.ipa}</div>}
      <div>{word.chineseGloss}</div>
      {word.englishDefinition && <div className="muted">{word.englishDefinition}</div>}
      <button
        type="button"
        className="secondary"
        onClick={() => void play(word.wordAudioAssetId)}
      >
        朗读单词
      </button>
      <section className="card stack">
        <strong>例句</strong>
        <div>{word.exampleSentenceEn}</div>
        {word.exampleSentenceZh && <div className="muted">{word.exampleSentenceZh}</div>}
        {word.exampleAudioAssetId && (
          <button type="button" className="secondary" onClick={() => void play(word.exampleAudioAssetId)}>
            朗读例句
          </button>
        )}
      </section>
    </div>
  );

  async function toggleFav() {
    if (!word) return;
    await appServices.vocabulary.setFavorite(word.id, !word.favorite);
    await load();
  }

  async function play(assetId: string) {
    if (!assetId) return;
    const s = await appServices.settings.get();
    await appServices.audio.play(assetId, s.playbackSpeed);
  }
}
